import styled from "styled-components";

export const Wrapper = styled.div`
  margin-left: auto;
  margin-right: auto;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const List = styled.ul`
  display: flex;
  gap: 20px;
`;

export const Item = styled.li`
  list-style: none;
`;

export const Image = styled.img`
  width: 180px;
`;
